import { ChartNode } from 'react-flame-graph';
import React from 'react';
import FooterNode from './FooterNode';
import FooterColors from './FooterColors';
import FooterDirectories from './FooterDirectories';
import FooterRemoved from './FooterRemoved';
import './Footer.css';
import { DisplayNode, Graph, ColorTree, NullableDepLink, LinkSet } from '../../types';

type Props = {
  focusedNode?: DisplayNode | ChartNode;
  focusedNodeId?: string;
  directoryColors: ColorTree;
  topLevelFolders: string[];
  dependencyGraph: Graph;
  reversedDependencyGraph: Graph;
  focusNode: (id: string) => void;
  removedLinks: LinkSet;
  addedLinks: LinkSet;
  removeLink: (link: NullableDepLink) => void;
  addLink: (link: NullableDepLink) => void;
  shortenFileName: (s?: string) => string;
};

const Footer = ({
  focusedNode,
  focusedNodeId,
  directoryColors,
  topLevelFolders,
  dependencyGraph,
  reversedDependencyGraph,
  focusNode,
  removedLinks,
  addedLinks,
  removeLink,
  addLink,
  shortenFileName,
}: Props) => {
  const nodeChildren = dependencyGraph[focusedNodeId ?? ''] ?? [];
  const nodeParents = reversedDependencyGraph[focusedNodeId ?? ''] ?? [];

  const hasLinkChanges = removedLinks.size > 0 || addedLinks.size > 0;

  return (
    <div className="footer">
      <div className="footer-inner">
        <div className="footer__item">
          <FooterNode
            focusedNode={focusedNode}
            focusedNodeId={focusedNodeId}
            nodeChildren={nodeChildren}
            nodeParents={nodeParents}
            shortenName={shortenFileName}
            focusNode={focusNode}
            removeLink={removeLink}
            addLink={addLink}
          />
        </div>
        {hasLinkChanges ? (
          <div className="footer__item">
            <FooterRemoved
              removedLinks={removedLinks}
              addedLinks={addedLinks}
              shortenName={shortenFileName}
              focusNode={focusNode}
              removeLink={removeLink}
              addLink={addLink}
            />
          </div>
        ) : null}
        <div className="footer__item">
          <FooterColors directoryColors={directoryColors} />
        </div>
        <div className="footer__item">
          <FooterDirectories topLevelFolders={topLevelFolders} shortenName={shortenFileName} />
        </div>
      </div>
    </div>
  );
};

export default Footer;
